"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getURL = exports.getNumDaysBetweenDates = exports.ISOStringToDate = exports.getCurrentISOString = exports.isNil = void 0;

var isNil = function isNil(value) {
  return value == null;
};

exports.isNil = isNil;

var getCurrentISOString = function getCurrentISOString() {
  return new Date().toISOString();
};

exports.getCurrentISOString = getCurrentISOString;

var ISOStringToDate = function ISOStringToDate(ISOString) {
  var utcMs = Date.parse(ISOString);

  if (Number.isNaN(utcMs)) {
    throw new Error('Invalid string passed to ISOStringToDate.');
  }

  return new Date(utcMs);
};

exports.ISOStringToDate = ISOStringToDate;

var getNumDaysBetweenDates = function getNumDaysBetweenDates(dateA, dateB) {
  var msInDay = 1000 * 60 * 60 * 24;
  return (dateA - dateB) / msInDay;
};

exports.getNumDaysBetweenDates = getNumDaysBetweenDates;

var getURL = function getURL() {
  return window.location.href;
};

exports.getURL = getURL;